import React from 'react';
import {useSearch} from 'modules/Search/hooks';
import PartnerItemSmall from "modules/Partner/components/PartnerItem/small";
import ProductsItemSearch from "modules/Partner/components/ProductsItem/search/search";
import EmptyContent from "shared/EmptyContent";
import Loader from "shared/Loader";
import Card from "shared/Card";
import Masonry from 'react-masonry-css'
import {useMobileContextDetect} from 'shared/DeviceDetect'
import {usePartnerOpen} from "modules/Partner/hooks";

const SearchResult = ({}) => {
    const { search, getMiniSiteResutlList, onClickProductMiniSite } = useSearch()
    const { partner } = usePartnerOpen()
    const isMobile = useMobileContextDetect();



    if(search?.isLoading){
        return (
            <Card variant={'secondary'}>
                <Loader />

            </Card>
        )
    }


   /* var items = [
        {id: 1, name: 'My First Item'},
        {id: 2, name: 'Another item'},
        {id: 3, name: 'Third Item'},
        {id: 4, name: 'Here is the Fourth'},
        {id: 5, name: 'High Five'}
    ];

    var items2 = [
        {id: 1, name: 1},
        {id: 2, name: 2},
        {id: 3, name: 3},
        {id: 4, name: 4},
        {id: 5, name: 5}
    ];

// Convert array to JSX items
    var items = items.map(function(item,index, i) {
        return  (
            <React.Fragment>
                <div>{item.name}</div>
                <div>{items2[index].name}</div>

            </React.Fragment>
        )
    });

    console.log('items', items)

    var items2 = items2.map(function(item,index, i) {
        return  <div>{item.name}</div>
    });*/

    /*return <Masonry
        breakpointCols={2}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
    >
        {items}
    </Masonry>*/

    return (
        <Card variant={'secondary'} data-cy={'search-result'}>
            <EmptyContent
                cardVariant={'secondary'}
                head={"Ничего не найдено"}
                isEmpty={!search.data?.products?.length}>
                <Masonry
                    breakpointCols={isMobile ? 2 : 4}
                    className="my-masonry-grid"
                    columnClassName="my-masonry-grid_column">
                        {
                            getMiniSiteResutlList()?.map((item, i) => (
                                <>
                                    {
                                        item.is_partner ?
                                            <PartnerItemSmall mb={1}  key={i} data={item}/> :
                                            <ProductsItemSearch
                                                isWithoutBaseUrl
                                                key={i}
                                                onOpenProduct={onClickProductMiniSite(item)}
                                                partner={partner.data}
                                                mb={1}  product={item}/>
                                    }
                                </>
                            ))
                        }
                </Masonry>
            </EmptyContent>
        </Card>
    )
}


export default SearchResult
